import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION5: PdfComponent = {
  type: 'section',
  id: 's5',
  title: '5. Rights and Duties of Kanda',
  content: [
    {
      type: 'bulletList',
      id: 's5bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'During the Term, Kanda shall:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'ensure that adequate Customer identification and verification procedures are undertaken for each prospective Customer in accordance with applicable credit application processes;',
              },
              {
                copy: 'notify the Subscriber of any variation and/or amendments to the Kanda Procedure Guide or equivalent operational documentation.',
              },
            ],
          },
        },
      ],
      prefix: '5',
    },
  ],
};
